"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function operationIdEquals(self, other) {
    return self.ns === other.ns && self.id === other.id;
}
exports.operationIdEquals = operationIdEquals;
function param(type) {
    return { type };
}
exports.param = param;
function operationId(ns, name, ...parameters) {
    let suffix = '';
    if (parameters.length > 0) {
        suffix = '_' + parameters.map(x => x.type).join('_');
    }
    return { ns, id: name + suffix };
}
exports.operationId = operationId;
//# sourceMappingURL=function.js.map